import { render, staticRenderFns } from "./notfound.vue?vue&type=template&id=397e28ee&scoped=true&"
import script from "./notfound.vue?vue&type=script&lang=js&"
export * from "./notfound.vue?vue&type=script&lang=js&"
import style0 from "./notfound.vue?vue&type=style&index=0&id=397e28ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397e28ee",
  null
  
)

export default component.exports